<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<!-- 				<el-divider content-position="center">
					<span style="color: red;font-size: 14px;">SKU不支持排序，如需精准查询SKU，请在商品页面先选好SKU再复制链接查询</span>
				</el-divider> -->
				<div class="item_container">
					<el-input style="margin: 10px;" @input="keywordChange" v-model="keyword"
						placeholder="关键词,多个关键词用空格号隔开">
						<template slot="prepend">搜索</template>
					</el-input>
					<div style="width: 100%;margin-left: 10px;">
						<el-button type="primary" size="mini" @click="selectall">全选</el-button>
						<el-button type="success" size="mini" @click="invertall">反选</el-button>
					</div>
					<div v-for="(item,index) in skudata" :key="index">
						<div class="item_box" :class="{active:item.active}" @click="select(item)" :key="key">
							<img style="width: 30px;" :src="item.skuOlnPic" />
							<span style="margin-left: 10px;">{{item.skuName}}</span>
						</div>
					</div>
				</div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>
	.item_container {
		color: #11192d;
		display: flex;
		flex-direction: row;
		font-size: 14px;
		font-weight: 400;
		margin-bottom: 16px;
		flex-wrap: wrap;
	}

	.item_box {
		box-sizing: border-box;
		align-items: center;
		background-color: #fff;
		border: 1px solid #dadde0;
		border-radius: 4px;
		cursor: pointer;
		display: flex;
		flex-direction: row;
		margin: 10px;
		max-width: calc(100% - 8px);
		padding: 2px;
		padding-right: 10px;
		position: relative
	}

	.item_box:hover {
		background-color: rgb(179, 216, 255);
	}

	.active {
		background-color: rgb(179, 216, 255);
	}
</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				key: Math.random(),
				keyword: '',
				modal_model: false,
				modal_title: 'SKU',
				modal_width: 1200,
				modal_height: 800,
				skudata: []
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {


		},
		methods: {
			selectall(){
				this.skudata.forEach((item) => {
					item.active = true
				})
				this.key = Math.random()
			},
			invertall(){
				this.skudata.forEach((item) => {
					item.active = !item.active
				})
				this.key = Math.random()
			},
			keywordChange() {
				this.skudata = this.data
				if (this.keyword) {
					let skudata = []
					let keyword = this.keyword.split(' ')
					keyword = keyword.filter((item) => {
						return item
					})
					this.skudata.forEach((item) => {
						let buff = false
						keyword.forEach((k) => {
							let skuName = item.skuName.replace(' ', '')
							if (skuName.toUpperCase().indexOf(k.toUpperCase()) !== -1) {
								buff = true
							}
						})
						if (buff) {
							skudata.push(item)
						}

					})
					this.skudata = skudata
				}
			},
			modal_onshow() {
				this.keyword = ''
				this.skudata = JSON.parse(JSON.stringify(this.data))
				this.skudata.forEach((item) => {
					item.active = false
				})
			},
			submit() {
				let data = this.skudata.filter((item) => {
					return item.active
				})
				data = data.map((item) => {
					return item.specCode
				})
				//console.log(data)
				this.$emit('submit', {
					code: data
				})
				this.modal_cancel()
			},
			select(data) {
				let obj = this.skudata.find((item) => {
					return item.skuName == data.skuName
				})
				if (obj) {
					obj.active = !obj.active
				}
				this.key = Math.random()
				console.log(data)
				// this.$emit('submit',{code:data.specCode})
				// this.modal_cancel()
			}
		},
		components: {

		}
	}
</script>